module.exports = __webpack_public_path__ + "static/media/LogoImovClick.11e646e1.svg";